import { Header, Password as PasswordComponent } from "components"
export const Password = () => {
 return (
  <>
   <Header />
   <PasswordComponent />
  </>
 )
}
